import PropTypes from 'prop-types'

import { getTextFromSelectedDropdownOption } from 'utils/formatters'
import { getDisplayName, getUrlParam } from 'utils/mixpanel'
import { toGlobalId } from 'utils/transformations/graphql'

export const withAnalytics = (WrappedComponent) => {
  const Wrapper = (props) => {
    const { mixpanel, location } = props

    const getExportRawDataModalSubmittedParams = ({
      integrationsDropdownOptions,
      options,
    }) => ({
      'Integration Type':
        getTextFromSelectedDropdownOption(
          integrationsDropdownOptions,
          toGlobalId('OrderExportIntegration', options.account_integration_id),
        ) || 'Basic Export',
      'Mark Exported Orders': options.mark_exported || 'false',
      ...getUrlParam(location),
    })

    const getExportAllDataModalSubmittedParams = ({
      statusesDefault,
      dateOptions,
      integrationsDropdownOptions,
      startDate,
      endDate,
      options,
    }) => ({
      'Order Status':
        statusesDefault.length !== 0
          ? statusesDefault.join(', ')
          : 'No order status selected',
      'Date Type':
        typeof options.search_by !== 'undefined'
          ? dateOptions[options.search_by - 1].text
          : 'No date type selected',
      'Date Range': `${startDate || 'No start date selected'} - ${
        endDate || 'No end date selected'
      }`,
      'Integration Type':
        getTextFromSelectedDropdownOption(
          integrationsDropdownOptions,
          toGlobalId('OrderExportIntegration', options.accounts_integration_id),
        ) || 'Basic Export',
      'Exclude Exported Orders': options.exclude_exported || 'false',
      'Mark Exported Orders': options.mark_exported || 'false',
      ...getUrlParam(location),
    })

    const trackers = {
      trackExportRawDataModalSubmitted: (config) =>
        mixpanel.track(
          'Orders List_Export Data Modal Submitted (Raw data)',
          getExportRawDataModalSubmittedParams(config),
        ),
      trackExportAllDataModalSubmitted: (config) =>
        mixpanel.track(
          'Orders List_Export Data Modal Submitted (All data)',
          getExportAllDataModalSubmittedParams(config),
        ),
    }

    return <WrappedComponent {...props} {...trackers} />
  }

  Wrapper.propTypes = {
    mixpanel: PropTypes.object,
    location: PropTypes.object.isRequired,
  }
  Wrapper.defaultProps = {
    mixpanel: { track: () => {} },
  }

  Wrapper.displayName = `withAnalytics(${getDisplayName(WrappedComponent)})`
  return Wrapper
}

export default withAnalytics
